// Readable durations: `toMs.minutes(30)` instead of `30 * 60 * 1000`. The target unit is named
// at the call site since some apis want ms (timers, Bottleneck) and others seconds (cookie maxAge).
// No months or years: they have no fixed length.

const unit = (factor: number) => (n: number) => n * factor;

export const toMs = {
  seconds: unit(1000),
  minutes: unit(60 * 1000),
  hours: unit(60 * 60 * 1000),
  days: unit(24 * 60 * 60 * 1000),
  weeks: unit(7 * 24 * 60 * 60 * 1000),
};

export const toSecs = {
  minutes: unit(60),
  hours: unit(60 * 60),
  days: unit(24 * 60 * 60),
  weeks: unit(7 * 24 * 60 * 60),
};
